"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class Sorter extends React.PureComponent {
        onChange = (e) => {
            const selectedOption = $(':selected', e.target).data();
            const sortBy = selectedOption.sortby;
            const sortDirection = selectedOption.sortdirection;
            this.props.onChangeSort(sortBy, sortDirection);
            flex.log(`changed sort by option: ${selectedOption}`);
        };

        getValue = (sortBy, sortDirection) => {
            return `${sortBy}-${sortDirection}`;
        };

        render() {
            let options = this.props.options ? this.props.options.map((o, k) => {
                let arrow = o.sortDirection === "ASC" ? "↑" : "↓";
                let title = flex.text(o.title, flex.fromCamelToSpacedString(o.title));
                return <option key={k} data-sortby={o.id} data-sortdirection={o.sortDirection} value={this.getValue(o.id, o.sortDirection)}>{title} {arrow}</option>;
            }) : false;

            let value = this.getValue(this.props.sortBy, this.props.sortDirection);

            return (
                <div className="form-group select rover col-sm-3 col-sm-offset-9">
                    <label className="control-label" htmlFor="rs-sort">Sort By</label>
                    <select value={value} className="form-control hasCustomSelect" id="rs-sort" onChange={this.onChange}>
                        {options}
                    </select>
                </div>);
        }
    }

    return Sorter;
};

module.exports = initComponent;